/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ApiUserKindFilter {
  All = 'All',
  InternalOnly = 'InternalOnly',
  ExternalOnly = 'ExternalOnly'
}
